import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { LocalStorageService } from 'app/core/storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ModuleGuard implements CanActivate {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const moduleId = route.data?.['moduleId'] as number | undefined;

    if (moduleId === undefined || this.localStorageService.getAvailableModules().includes(moduleId)) {
      return true;
    }

    this.router.navigate(['/page-not-found']);
    return false;
  }
}
